import type { CSSProperties, FC, ReactNode } from 'react'

import { FigLabel } from '@/components/generals/fig-label'
import { Reveal } from '@/components/generals/reveal'

const delay = (value: number): CSSProperties => ({ '--delay': `${value}ms` } as CSSProperties)

/**
 * Home section 12: the closing call, set across the full width. The studio email and the
 * Engage the studio button follow directly below in the footer's contact band.
 */
export const Closing: FC = (): ReactNode => {
    return (
        <section id='engage' aria-labelledby='closing-title' className='relative overflow-hidden border-t border-hairline'>
            <Reveal className='px-gutter pb-20 pt-20 desk:pb-28 desk:pt-28'>
                <FigLabel fig='12' title='Engage' detail='Start a commission' note='Replies within two working days' />

                <h2 id='closing-title' className='mt-14 font-heading text-[clamp(52px,11.4vw,210px)] font-medium leading-[0.9] tracking-[-0.045em] desk:mt-20'>
                    <span className='reveal-line'>
                        <span className='reveal-inner text-ink' style={delay(80)}>
                            Let&apos;s draw
                        </span>
                    </span>

                    <span className='reveal-line'>
                        <span className='reveal-inner text-dim' style={delay(180)}>
                            something.
                        </span>
                    </span>
                </h2>
            </Reveal>
        </section>
    )
}
